import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "label"]

  connect() {
    this.updateSelection()
  }

  selectOption(event) {
    const label = event.currentTarget
    const value = label.dataset.value
    const radio = this.element.querySelector(`input[type="radio"][value="${value}"]`)
    
    if (radio) {
      radio.checked = true
      radio.dispatchEvent(new Event('change', { bubbles: true }))
      this.updateSelection()
    }
  }

  updateSelection() {
    // Alle Labels zurücksetzen
    this.labelTargets.forEach(label => {
      label.classList.remove('border-green-500', 'border-red-500', 'bg-green-200', 'bg-red-200')
      label.classList.add('border-transparent')
    })
    
    // Ausgewähltes Radio finden und entsprechendes Label hervorheben
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked')
    if (checkedRadio) {
      const value = checkedRadio.value
      const label = this.element.querySelector(`label[data-value="${value}"]`)
      
      if (label) {
        if (value === 'true') {
          label.classList.remove('border-transparent', 'bg-green-100')
          label.classList.add('border-green-500', 'bg-green-200')
        } else {
          label.classList.remove('border-transparent', 'bg-red-100')
          label.classList.add('border-red-500', 'bg-red-200')
        }
      }
    }
  }
}
